export enum NotificationActionEnum {
  assigned = 'ASSIGNED',
  assignation = 'ASSIGNATION',
  transiting = 'TRANSITING',
  negotiation = 'NEGOTIATION',
  completed = 'COMPLETED',
}